var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScore148Filled = function SvgIconScore148Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm-5.5 10.6a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5Zm1.18 14.29-3.35-.57c.63-3.72 3.86-6.41 7.68-6.41s7.04 2.7 7.68 6.41l-3.35.57c-.35-2.08-2.17-3.59-4.32-3.59-2.15 0-3.97 1.51-4.32 3.59h-.02Zm9.82-9.29a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: "current"
  })));
};
export default SvgIconScore148Filled;